import React from 'react';
import PropTypes from 'prop-types';
import withInit from 'WithInit';
import EsignLandingPageFullWidthUploadPanelLayout from './EsignLandingPageFullWidthUploadPanelLayout';

export class EsignLandingPage extends React.PureComponent {
  componentDidMount() {
    window.Upload.activateUploadButtonById('uploadPDFLarge');
    window.Upload.activateUploadButtonById('uploadPDFLargeMobile');

    // Allow users to upload photos
    window.Upload.photoToPDF.init();
  }

  render() {
    return <EsignLandingPageFullWidthUploadPanelLayout />;
  }
}

EsignLandingPage.defaultProps = {
  layout: 'smallUploadPanel',
};

EsignLandingPage.propTypes = {
  layout: PropTypes.string,
};

export default withInit(EsignLandingPage);



// WEBPACK FOOTER //
// ./src-react/EsignLandingPage/index.jsx